import { SaveButton, Toolbar } from 'react-admin'

const TextModelEditToolBar = () => {

  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  )
}

export default TextModelEditToolBar